<template>
  <div>
    <p :class="style['error-text']">{{ errorMessage }}</p>
    <input
      type="button"
      :class="[style['user-input'], style['facebook']]"
      :style="computedFacebookButton"
      :value="$t('user_top.sign_in_with_facebook')"
      :disabled="isSending"
      @click="onClick"
    />
  </div>
</template>

<script>
import style from '../ChatWindow/Users/scss/_users.scss'
import { EventBus } from 'ChatWidget/EventBus'
import { useAppStore } from 'Store/app'
import { mapState } from 'pinia'
import { useSettingsStore } from 'Store/settings'
import { useChatStore } from 'Store/chat'

export default {
  name: 'FacebookLoginButton',

  setup() {
    const appStore = useAppStore()

    return { appStore }
  },

  data() {
    return {
      style,
      errorMessage: null,
      facebookWindow: null,
      isSending: false
    }
  },

  computed: {
    ...mapState(useChatStore, {
      chatID: 'chatId'
    }),
    ...mapState(useSettingsStore, {
      hotelID: 'getHotelId',
      facilitySignInEnabled: 'getFacilitySignIn'
    }),
    computedFacebookButton() {
      if (this.isSending) return 'opacity: 0.4;'
    },
    facebookAuthorizeURL() {
      return `${this.appStore.baseURL}users/auth/facebook?chat_id=${this.chatID}`
    }
  },

  mounted() {
    EventBus.$on('refresh-oauth-login', (json) => {
      if (this.facebookWindow) this.facebookWindow.close()
    })
  },

  methods: {
    onClick() {
      if (this.facilitySignInEnabled) {
        this.newFacebookLogin()
      } else {
        this.openFacebookLogin()
      }
    },
    newFacebookLogin() {
      const url = `${this.appStore.baseURL}users/auth/facebook_membership?hotel_id=${this.hotelID}&chat_id=${this.chatID}`
      this.facebookWindow = window.open(url, 'popup', 'width=600, height=600')
    },
    openFacebookLogin() {
      this.isSending = true
      this.facebookWindow = window.open(this.facebookAuthorizeURL, 'popup', 'width=600, height=600')
    }
  }
}
</script>
